import { ReactNode, SyntheticEvent } from 'react';
import {
  Popover as MUIPopover,
  PopoverProps as MUIPopoverProps,
} from '@mui/material';

type OriginType = {
  horizontal: number | 'center' | 'left' | 'right';
  vertical: number | 'top' | 'center' | 'bottom';
};

type AtomMUIProps = {
  children?: ReactNode;
  open: boolean;
  anchorEl?: Element;
  anchorOrigin?: OriginType;
  transformOrigin?: OriginType;
  onClose?: (event: SyntheticEvent<any>) => void;
  onClick?: (event: SyntheticEvent<any>) => void;
  slotProps?: any;
};

export type PopoverProps = AtomMUIProps;

// NOTE - Popover does not expose the content scrolling ref
//        If you need to detect scrolling, use @mui/material/Popper
export const Popover = (props: PopoverProps) => {
  const MUIProps: MUIPopoverProps = props;

  return <MUIPopover {...MUIProps} />;
};

export default Popover;
